<template>
  <gp-tooltip :visible="!!path">
    <template v-if="path">
      {{ path.displayName }}
    </template>
  </gp-tooltip>
</template>

<script>
import Path from '../../../../classes/models/Path'

import GpTooltip from '../../../../../vue/common/Tooltip/Tooltip.vue'

export default {
  name: 'GpaPathTooltip',
  components: { GpTooltip },
  props: {
    path: { required: false, type: Path, default: null },
  },
}
</script>
